import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import type { User } from '../../../types';
import type { ChangeCatalogItem, ChangeType } from '../../../types/changes';
import { STATUS_FILTER_OPTIONS, TYPE_LABELS } from '../changeLabels';
import { CHANGE_FIELD_LIMITS } from '../changeValidation';
import ChangeScopeFilters from './ChangeScopeFilters';

export interface ChangeListFilterValues {
  search: string;
  status: string;
  type: string;
  categoryId: string;
  project: string;
  ownerId: string;
}

interface Props {
  values: ChangeListFilterValues;
  onChange: (patch: Partial<ChangeListFilterValues>) => void;
  users: User[];
  categories: ChangeCatalogItem[];
}

const ChangeListFilters: React.FC<Props> = ({ values, onChange, users, categories }) => (
  <Row className="g-2 mb-3">
    <Col xs={12} md={3}>
      <Form.Control
        placeholder="Pesquisar por título, descrição ou projeto"
        value={values.search}
        maxLength={CHANGE_FIELD_LIMITS.shortText}
        onChange={(event) => onChange({ search: event.target.value })}
      />
    </Col>
    <Col xs={6} md={2}>
      <Form.Select
        value={values.status}
        onChange={(event) => onChange({ status: event.target.value })}
      >
        <option value="">Todos os status</option>
        {STATUS_FILTER_OPTIONS.map((entry) => (
          <option key={entry.value} value={entry.value}>
            {entry.label}
          </option>
        ))}
      </Form.Select>
    </Col>
    <Col xs={6} md={2}>
      <Form.Select value={values.type} onChange={(event) => onChange({ type: event.target.value })}>
        <option value="">Todos os tipos</option>
        {(Object.keys(TYPE_LABELS) as ChangeType[]).map((value) => (
          <option key={value} value={value}>
            {TYPE_LABELS[value]}
          </option>
        ))}
      </Form.Select>
    </Col>
    <ChangeScopeFilters
      values={{ categoryId: values.categoryId, project: values.project, ownerId: values.ownerId }}
      onChange={onChange}
      users={users}
      categories={categories}
    />
  </Row>
);

export default ChangeListFilters;
